module.exports = __webpack_public_path__ + "img/12_37.2d5993c8.png";